<template>
    <feature-toggle :toggle="canEditChannel">
        <simple-button :disabled="isDisabled" @click="onSelect">
            {{ toSentenceCase($t('preparation.buttons.select')) }}
        </simple-button>
    </feature-toggle>
</template>

<script>
import featureFlags from '@enums/feature-flags';
import { toSentenceCase } from '@/js/utils/string-utils';

const { canEditChannel } = featureFlags;

export default {
    data() {
        return {
            canEditChannel,
        };
    },
    computed: {
        isDisabled() {
            return this.params.isCategoryDisabled();
        },
    },
    methods: {
        toSentenceCase,
        onSelect() {
            this.params.onSelect(this.params.data.categoryKey);
        },
    },
};
</script>
